module.exports = __webpack_public_path__ + "static/img/son9.03ae240f.png";